import { z } from 'zod'
import { redirect, type LoaderFunctionArgs } from 'react-router'
import { useLoaderData } from 'react-router'
import blogStyles from '~/styles/pages/blog-home.css?url'
import paginationStyles from '~/styles/pages/post-pagination.css?url'
import { title } from './_content.blog._index'
import {
  PostCollection,
  postCollectionLinks,
} from '~/components-v2/post-collection/post-collection'
import { styles as componentStyles } from '~/components-v2'
import { getBlogPostsForPage } from '~/services/contentful/blog.server'
import { BlogPagination } from '~/components/blog/pagination'

export const links = () => [
  ...postCollectionLinks(),
  { rel: 'stylesheet', href: componentStyles.carouselButtonNext },
  { rel: 'stylesheet', href: paginationStyles },
  { rel: 'stylesheet', href: blogStyles },
]
export { meta } from '~/utils'

export const loader = async ({ params }: LoaderFunctionArgs) => {
  const parsed = z
    .object({
      page: z.coerce.number().int().optional().default(2),
    })
    .safeParse(params)

  if (!parsed.success) {
    throw new Response('Page not found', { status: 404 })
  }

  const { page } = parsed.data

  if (page <= 1) {
    throw redirect('/blog')
  }

  const { posts, totalPages } = await getBlogPostsForPage({ page: page - 2 })

  if (page > totalPages) {
    throw new Response('Page not found', { status: 404 })
  }

  return {
    posts,
    page,
    totalPages,
    title,
  }
}

export default function () {
  const { page, posts, totalPages } = useLoaderData<typeof loader>()

  return (
    <main className="blog-layout">
      <PostCollection posts={posts} variant="blog-grid" />
      <BlogPagination page={page} totalPages={totalPages} />
    </main>
  )
}
